import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import StudentProfile from '../components/profile/StudentProfile';
import EmployerProfile from '../components/profile/EmployerProfile';

const ProfilePage: React.FC = () => {
  const { userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Check if user is an employer based on profile type
  const isEmployer = userProfile && userProfile.userType === 'employer';

  return isEmployer ? <EmployerProfile /> : <StudentProfile />;
};

export default ProfilePage; 